import React, { useState, useMemo } from 'react';
import { DOCUMENT_TYPES } from '../constants';
import DocumentCard from '../components/DocumentCard';
import HowItWorks from '../components/HowItWorks';
import PromoSection from '../components/PromoSection';
import Icon from '../components/Icon';

const HomePage: React.FC = () => {
  const [searchTerm, setSearchTerm] = useState('');

  const filteredDocs = useMemo(() => {
    if (!searchTerm) {
      return DOCUMENT_TYPES;
    }
    return DOCUMENT_TYPES.filter(doc =>
      doc.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
      doc.description.toLowerCase().includes(searchTerm.toLowerCase())
    );
  }, [searchTerm]);

  return (
    <div className="px-4 sm:px-6 lg:px-[70px] py-12">
      <header className="text-center mb-12">
        <h1 className="text-4xl md:text-5xl font-extrabold text-[var(--color-text-heading)]">
          منشئ الصفحات القانونية
        </h1>
        <p className="mt-4 text-lg text-[var(--color-text-body)] max-w-2xl mx-auto">
          أنشئ وثائقك القانونية بسهولة وسرعة، مدعومة بالذكاء الاصطناعي.
        </p>

        <div className="mt-5 mb-12 max-w-md mx-auto">
          <div className="relative">
            <input
              type="text"
              placeholder="ابحث عن صفحة قانونية..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="w-full pr-4 pl-12 py-3 border border-[var(--color-border)] rounded-xl shadow-lg focus:ring-2 focus:ring-[var(--color-primary)] focus:border-[var(--color-primary)] transition-all bg-[var(--color-input-bg)] text-[var(--color-text-body)] placeholder:text-[var(--color-text-body)]/70 text-base"
            />
            <div className="absolute inset-y-0 left-0 flex items-center pl-5 text-[var(--color-text-body)]/50 pointer-events-none">
              <Icon name="Search" className="w-5 h-5" />
            </div>
          </div>
        </div>
      </header>

      <main>
        <div className="flex overflow-x-auto sm:grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 sm:gap-8 mb-16 pb-4 -mx-4 sm:mx-0 px-4 sm:px-0">
          {filteredDocs.map(doc => (
            <DocumentCard key={doc.id} doc={doc} />
          ))}
        </div>
        
        {filteredDocs.length === 0 && (
          <div className="text-center py-16 bg-[var(--color-surface)] rounded-xl shadow-md border border-[var(--color-border)]">
            <p className="text-xl text-[var(--color-text-body)]">لم يتم العثور على نتائج. حاول البحث بكلمة أخرى.</p>
          </div>
        )}

        <HowItWorks />

        <PromoSection />
      </main>
    </div>
  );
};

export default HomePage;